import { Deserializable } from '../../deserializable';
import { CaseRequestStatusHistoryDto } from './case-request-status-history-dto.model';

export class CaseRequestDto implements Deserializable {
  public RequestTypeCode: string;
  public CreatedDate?: Date;
  public ProductDescription: string;
  public ProductCode: string;
  public SwitchedSubaccountsInfo: string;
  public AccountLTV?: number;
  public StatusCode: string;
  public AgentFullName: string;
  public AgentCompany: string;
  public DirectCustomerFullName: string;
  public AgentID?: number;
  public AgentIDAsHash: string;
  public DirectCustomerID?: number;
  public DirectCustomerIDAsHash: string;
  public CaseRequestStatusHistoryList: Array<CaseRequestStatusHistoryDto>;

  public deserialize(input: any): this {
    Object.assign(this, input);
    this.CaseRequestStatusHistoryList = input.CaseRequestStatusHistoryList.map(
      (caseRequestStatusHistoryDto: CaseRequestStatusHistoryDto) =>
        new CaseRequestStatusHistoryDto().deserialize(caseRequestStatusHistoryDto)
    );

    return this;
  }
}
